import React from 'react';

const SvgTrimet = ({ title, ...props }) => (
  <svg viewBox="0 0 50 50" {...props}>
    {title ? <title>{title}</title> : null}
    <path
      d="M50 25c0 13.8-11.2 25-25 25S0 38.8 0 25 11.2 0 25 0s25 11.2 25 25z"
      fill="#d1441e"
    />
    <path
      d="M38.3 18C37.6 11.3 32 6 25.1 6c-6.9 0-12.5 5.2-13.2 11.9-3.4 2.5-5.3 6.5-5.3 10.6 0 2.2.6 4.5 1.8 6.6 2.4 4.2 6.9 6.6 11.5 6.6 1.7 0 3.5-.4 5.2-1.1 1.7.7 3.5 1.1 5.2 1.1 4.6 0 9-2.4 11.5-6.6 1.2-2.1 1.8-4.4 1.8-6.6-.1-4-2-7.9-5.3-10.5zm-13.2-8c3.9 0 7.1 2.4 8.5 5.7-1.1-.3-2.2-.4-3.4-.4-4.6 0-9 2.4-11.5 6.6-.5.9-.9 1.8-1.1 2.7-1.1-1.5-1.7-3.4-1.7-5.4 0-5 4.1-9.1 9.2-9.2zm2.7 13.9c.7 1.2 1 2.4 1.2 3.6-1.2.6-2.5.9-3.9.9s-2.8-.3-4-.9c.1-1.2.5-2.4 1.2-3.6.7-1.2 1.7-2.2 2.8-3 1.1.8 2 1.8 2.7 3zm-15.9 9.2c-.8-1.5-1.2-3-1.2-4.6 0-2 .6-3.9 1.8-5.5 1.6 5.4 6.7 9.4 12.7 9.4 1.1 0 2.2-.2 3.2-.4-.7 1.8-2.1 3.4-3.9 4.4-1.5.8-3 1.2-4.6 1.2-3.2.1-6.3-1.5-8-4.5zm26.3 0c-1.7 3-4.8 4.6-8 4.6-.3 0-.6 0-.9-.1 2.4-2.5 3.7-5.8 3.7-9.2 0-2.2-.6-4.5-1.8-6.6-.5-.9-1.2-1.8-1.9-2.5.3 0 .6-.1.9-.1 1.6 0 3.1.4 4.6 1.2 3 1.7 4.6 4.8 4.6 8 0 1.7-.4 3.3-1.2 4.7z"
      fill="#fff"
    />
  </svg>
);

export default SvgTrimet;
